import { persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";
import store from "../store";
import { select, put, takeLatest } from "redux-saga/effects";
import * as authDuck from "./auth.duck";
import * as applicationDuck from "./application.duck";
const getAuth = (store) => store.auth;

const getPreferences = (store) => store.preferences;
export const defaultLandingPage = "/contracts";
export const actionTypes = {
    // PREFERENCES_SET_CONTRACTS_VIEWMODE: "[PREFERENCES_SET_CONTRACTS_VIEWMODE]",
    // PREFERENCES_SET_CONTRACTS_DISPLAYIMAGES: "[PREFERENCES_SET_CONTRACTS_DISPLAYIMAGES]",
    // PREFERENCES_SET_CONTRACTS_FIELDS: "[PREFERENCES_SET_CONTRACTS_FIELDS]",
    // PREFERENCES_SET_CONTRACTS_FILTERS: "[PREFERENCES_SET_CONTRACTS_FILTERS]",
    // PREFERENCES_SET_NOTIFICATIONS: "[PREFERENCES_SET_NOTIFICATIONS]",
    // PREFERENCES_SET_C_NOTIFICATIONS: "[PREFERENCES_SET_C_NOTIFICATIONS]",
    PREFERENCES_SET_PENDING_ACTION_FILTER: "[PREFERENCES_SET_PENDING_ACTION_FILTER]",
    PREFERENCES_SET_LANDING_PAGE: "[PREFERENCES_SET_LANDING_PAGE]",
};

const initialPreferencesState = {
    // contractsPage: {
    //     viewMode: 1,
    //     displayImages: false,
    //     fields: [
    //         { caption: "Project Name", dataField: "project", show: true },
    //         { caption: "Contract Name", dataField: "name", show: true },
    //         { caption: "Contract Type", dataField: "contracttype", show: true },
    //         { caption: "Supplier", dataField: "contractorcompany", show: true },
    //         { caption: "Original Contract Price", dataField: "contractvalue", show: false, dataType: "price" },
    //         { caption: "Current Contract Price", dataField: "currentcontractvalue", show: true, dataType: "price" },
    //         { resource: "GENERAL.FORMS.FIELD.START_DATE", dataField: "startdate", show: false, dataType: "date" },
    //         { caption: "Original Completion Date", dataField: "completedate", show: false, dataType: "date" },
    //         { caption: "Current Completion Date", dataField: "completiondate", show: true, dataType: "date" },
    //         { caption: "Total Certified", dataField: "totalcertified", show: false },
    //         { caption: "Lead Consultant/Contractor", dataField: "contractmanager", show: false },
    //         { caption: "Lead Client", dataField: "employer", show: false },
    //         { caption: "Lead PM/SM", dataField: "projectmanager", show: false },
    //     ],
    //     filters: [
    //         { caption: "Project Name", dataField: "project", show: false },
    //         { caption: "Contract Type", dataField: "contracttype", show: false },
    //         { caption: "Supplier", dataField: "contractorcompany", show: false },
    //         { caption: "Hubs", dataField: "hubid", dataLabelField: "hub", show: false },
    //         { caption: "Areas", dataField: "areaid", dataLabelField: "area", show: false },

    //     ],
    // },
    // notifications: null,
    // contractNotifications: [],
    // contractTags: [],
    allLandingPages: {},
    landingpage: defaultLandingPage,
    actionFilters: {
        showRecurring: true,
        showOverdue: true,
        show7Days: true,
        showUpcoming: true,
    },
};

//PREFERENCES ARE SUPPOSED TO VARY BETWEEN PRODUCTS AND VERSIONS, UNIQUE NAME PROVIDED FOR EACH
const storageKey = "FD-Pref1" + process.env.REACT_APP_PRODUCT_KEY;
export const reducer = persistReducer({ storage, key: storageKey }, (state = initialPreferencesState, action) => {
    switch (action.type) {
        case actionTypes.PREFERENCES_SET_PENDING_ACTION_FILTER: {
            return { ...state, actionFilters: { ...state.actionFilters, ...action.payload } };
        }
        case actionTypes.PREFERENCES_SET_LANDING_PAGE: {
            return { ...state, landingpage: action.payload.landingpage, allLandingPages: { ...state.allLandingPages, [action.payload.accountid]: action.payload.landingpage } };
        }
        default:
            return state;
    }
});
export const actions = {
    setLandingPage: (landingpage) => {
        if (!landingpage) landingpage = defaultLandingPage;
        const authStore = store.getState().auth;
        if (authStore.userProfile.accountid) {
            return { type: actionTypes.PREFERENCES_SET_LANDING_PAGE, payload: { landingpage, accountid: authStore.userProfile.accountid } };
        }
        return { type: "" };
    },
    setPendingActionFilter: (propertyName, value) => ({ type: actionTypes.PREFERENCES_SET_PENDING_ACTION_FILTER, payload: { [propertyName]: value } }),

    // setContractsViewMode: (viewMode) => ({ type: actionTypes.PREFERENCES_SET_CONTRACTS_VIEWMODE, payload: { viewMode } }),
    // setContractsDisplayImages: (displayImages) => ({ type: actionTypes.PREFERENCES_SET_CONTRACTS_DISPLAYIMAGES, payload: { displayImages } }),
    // setContractsFields: (fields) => ({ type: actionTypes.PREFERENCES_SET_CONTRACTS_FIELDS, payload: { fields } }),
    // setContractsFilters: (filters) => ({ type: actionTypes.PREFERENCES_SET_CONTRACTS_FILTERS, payload: { filters } }),
    // setUserNotifications: (notifications) => ({ type: actionTypes.PREFERENCES_SET_NOTIFICATIONS, payload: { notifications } }),
    // setContractNotifications: (contractid, notifications) => ({ type: actionTypes.PREFERENCES_SET_C_NOTIFICATIONS, payload: { contractid, notifications } }),
};


export function* saga() {
    yield takeLatest([applicationDuck.actionTypes.APPLICATION_LOADED, authDuck.actionTypes.AUTH_LOAD_COMPLETED], function* preferencesStartupTriggerSaga() {
        try {
            //SET LANDING PAGE BASED ON ACCOUNT IF DEFINED
            const authStore = yield select(getAuth);
            const preferenceStore = yield select(getPreferences);
            if (!authStore || !authStore.userProfile || !authStore.authToken || !authStore.csrfToken || !authStore.authToken.token || !authStore.csrfToken.token) {
                return;
            }

            let landingPageForAccount = preferenceStore.allLandingPages[authStore.userProfile.accountid];
            if (!landingPageForAccount) {
                landingPageForAccount = defaultLandingPage;
            }
            if (landingPageForAccount !== preferenceStore.landingpage) {
                 yield put(actions.setLandingPage(landingPageForAccount));
            }

        } catch {
            console.log(
                "error setting admin menu items in preferencesStartupTriggerSaga"
            );
        }
    }
    );
}

